<div class="row">
  <div class="col-6">
    <div class="card" style="box-shadow: none;">
      <div class="card-body">
        @if (!startUpload) {
          <file-pond #myPond [options]="pondOptions" (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondRemoveFile()"></file-pond>
        }
        @if (startUpload) {
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <h6 class="mb-0">
                <b [ngClass]="progress === 100 ? 'text-success' : 'text-info'">{{ progress }}%</b>
                @if (progress < 100) {
                  <span>Uploaded </span>
                }
                @if (progress === 100) {
                  <span>Complete</span>
                }
              </h6>
            </div>
            <div class="flex-shrink-0">
              <h6 [ngClass]="timeLeft === 'Done' ? 'text-success' : ''" class="mb-0">{{ timeLeft }}</h6>
            </div>
          </div>
        }
        @if (startUpload) {
          <div class="progress bg-primary-subtle">
            <div class="progress-bar bg-secondary" role="progressbar" [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        }
      </div>
      <div class="card-footer border-0">
        <div class="text-center">
          @if (!startUpload) {
            <button type="button" (click)="uploadFile()" class="btn btn-primary" [disabled]="!canUpload">Upload</button>
          }
          @if (startUpload && timeLeft !== 'Done') {
            <button (click)="cancelUpload()" class="btn btn-danger">Cancel</button>
          }
        </div>
      </div>
    </div>
    @if (videoSource) {
      <form class="mt-3" [ngClass]="{ 'was-validated': submitted }">
        <div class="mb-3">
          <label for="speaker" class="form-label">Number of speakers <span class="text-danger">*</span></label>
          <ng-select id="speaker" [items]="speakers" bindLabel="name" bindValue="value" [searchable]="true" name="speakers" [(ngModel)]="speakerSelected" [ngModelOptions]="{standalone: true}" placeholder="Choose number of speakers" required></ng-select>
          <div class="invalid-feedback">Please select the number of speakers.</div>
        </div>
        @if (speakerSelected === 'n') {
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="start_time" class="form-label">Voice sample start time <span class="text-danger">*</span></label>
              <input type="number" class="form-control" id="start_time" placeholder="Enter start time" [(ngModel)]="baseline_start_time" [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback">Please enter a valid start time.</div>
            </div>
            <div class="col-md-6 mb-3">
              <label for="end_time" class="form-label">Voice sample end time <span class="text-danger">*</span></label>
              <input type="number" class="form-control" id="end_time" placeholder="Enter end time" [(ngModel)]="baseline_end_time" [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback">Please enter a valid end time.</div>
            </div>
            <div class="col-12">
              <p class="text-info">To mark the baseline start and end times, select the corresponding time on the video and click the 'Mark' button.</p>
            </div>
          </div>
        }
      </form>
    }
    @if (videoSource && error_data && !speakerSelected) {
      <div class="alert alert-danger mt-3">
        {{ message_error }}
      </div>
    }
  </div>
  <div class="col-6">
    <h1>Preview</h1>
    <div class="ratio ratio-16x9">
      @if (videoSource) {
        <video crossorigin="anonymous" #videoElement controls></video>
      }
      @if (!videoSource) {
        <div class="d-flex justify-content-center align-items-center h-100"> No Video file has been selected yet. </div>
      }
    </div>
    @if (videoSource && speakerSelected === 'n') {
      <div class="mt-2 text-center">
        <button type="button" (click)="markTime('start')" class="btn btn-secondary me-3">Mark Start Baseline</button>
        <button type="button" (click)="markTime('end')" class="btn btn-secondary">Mark End Baseline</button>
      </div>
    }
  </div>
</div>